/**
 * Pages of the web app that something outside it links to — emails above all.
 *
 * The API builds its links from this table and the web app's router is built from it,
 * so an emailed link and the page it opens cannot drift apart. They did once: reset and
 * invitation emails linked to `/reset-password` and `/join`, pages that never existed,
 * while each side's own tests passed.
 */

export const WEB_PAGES = {
  login: '/login',
  signup: '/signup',
  acceptInvite: '/invite',
  forgotPassword: '/forgot',
  resetPassword: '/reset',
  /** The instructor console. Approval emails open it. */
  classConsole: '/class',
} as const;

export type WebPage = keyof typeof WEB_PAGES;

/** An absolute link to one of those pages, with its query parameters encoded. */
export function webPageUrl(
  origin: string,
  page: WebPage,
  query: Readonly<Record<string, string>> = {},
): string {
  const url = new URL(WEB_PAGES[page], origin);
  for (const [name, value] of Object.entries(query)) url.searchParams.set(name, value);
  return url.toString();
}
